import type { FreeToolCategory } from '../types'

/**
 * Static fallback that mirrors `0019_free_tools_seed_data.sql` exactly.
 * Used when the API is offline or `VITE_API_URL` is not set, so the
 * gallery still looks alive in development.
 *
 * Source of truth: the migration file. If we change the seed there, we
 * sync this file. The runtime always prefers the API response.
 */
export const FREE_TOOLS_FALLBACK: FreeToolCategory[] = [
  {
    id: 'cat-dev',
    title: 'أدوات المطورين',
    titleEn: 'Developer Tools',
    icon: 'fa-code',
    sortOrder: 0,
    isActive: true,
    createdAt: '',
    updatedAt: '',
    count: 8,
    tools: [
      {
        id: 'free-ai-visibility-checker',
        categoryId: 'cat-dev',
        title: 'فاحص ظهور الموقع في الـ AI',
        titleEn: 'AI Visibility Checker',
        description:
          'اعرف لو ChatGPT و Claude و Perplexity يقدروا يقروا موقعك فعلاً. بنفحص وصول الكراولرز، والمحتوى في الـ HTML الخام، والـ schema، وrobots.txt، وندّيك الحلول خطوة بخطوة.',
        icon: 'fa-magnifying-glass-chart',
        url: '/freetools/ai-visibility-checker',
        isExternal: false,
        sortOrder: 1,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-token-counter',
        categoryId: 'cat-dev',
        title: 'عدّاد التوكنز',
        titleEn: 'Token Counter',
        description:
          'احسب عدد التوكنز والتكلفة التقديرية لأي نص قبل ما تبعته للموديل — يدعم العربي والإنجليزي.',
        icon: 'fa-hashtag',
        url: '/freetools/token-counter',
        isExternal: false,
        sortOrder: 1,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-ai-cost-calculator',
        categoryId: 'cat-dev',
        title: 'حاسبة تكلفة الـ AI',
        titleEn: 'AI Cost Calculator',
        description:
          'قدّر فاتورتك الشهرية لأي LLM API حسب عدد الطلبات والتوكنز، وشوف أرخص بديل.',
        icon: 'fa-calculator',
        url: '/freetools/ai-cost-calculator',
        isExternal: false,
        sortOrder: 2,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-claude-md-generator',
        categoryId: 'cat-dev',
        title: 'مولّد CLAUDE.md / AGENTS.md',
        titleEn: 'CLAUDE.md / AGENTS.md Generator',
        description:
          'جاوب على أسئلة بسيطة واحصل على ملف توجيهات احترافي لأدوات الـ AI (Claude Code، Cursor) يفهم مشروعك من أول رسالة.',
        icon: 'fa-file-code',
        url: '/freetools/claude-md-generator',
        isExternal: false,
        sortOrder: 3,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-prompt-generator',
        categoryId: 'cat-dev',
        title: 'مولّد البرومبتات الذكي',
        titleEn: 'Interactive Prompt Generator',
        description:
          'اكتب فكرتك بالعربي واحصل على برومبت احترافي بالإنجليزي مع شرح ونصائح ونسخ بديلة — لـ Midjourney و Sora و ChatGPT وغيرهم.',
        icon: 'fa-wand-magic-sparkles',
        url: '/freetools/prompt-generator',
        isExternal: false,
        sortOrder: 4,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'free-color-picker',
        categoryId: 'cat-dev',
        title: 'منتقي الألوان',
        titleEn: 'Color Picker',
        description:
          'حوّل أي لون بين HEX و RGB و HSL، واحصل على تدرّجاته الجاهزة ومكتبة ألوان سريعة — كله في المتصفح بدون رفع أي حاجة.',
        icon: 'fa-palette',
        url: '/freetools/color-picker',
        isExternal: false,
        sortOrder: 5,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-brand-mention-tracker',
        categoryId: 'cat-dev',
        title: 'متتبّع ذِكر البراند في الـ AI',
        titleEn: 'AI Brand Mention Tracker',
        description:
          'اسأل محرك بحث AI حقيقي عن مجالك وشوف إنت مذكور في إجاباته ولا المنافس — بالأدلة والمصادر. شقيق فاحص الظهور بس بيقيس النتيجة مش القدرة.',
        icon: 'fa-bullseye',
        url: '/freetools/brand-mention-tracker',
        isExternal: false,
        sortOrder: 6,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-object-talk-studio',
        categoryId: 'cat-dev',
        title: 'Object Talk Studio',
        titleEn: 'Object Talk Studio',
        description:
          'خلّي أي حاجة تتكلم — قهوة، برجر، عربية، شنطة. من الفكرة للريل الجاهز: سكريبت، صوت، أنيميشن، وترجمة.',
        icon: 'fa-comments',
        url: '/freetools/object-talk-studio',
        isExternal: false,
        sortOrder: 8,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-landing-page-doctor',
        categoryId: 'cat-dev',
        title: 'Landing Page Doctor',
        titleEn: 'Landing Page Doctor',
        description:
          'AI Conversion Audit لأي بيزنس — يفهم نوع صفحتك وهدفها ويقيمها حسب Rubric خاص بكل نوع، مع Visual Map و Fix with AI.',
        icon: 'fa-stethoscope',
        url: '/freetools/landing-page-doctor',
        isExternal: false,
        sortOrder: 9,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-ad-creative-analyzer',
        categoryId: 'cat-dev',
        title: 'محلل الإعلانات الإبداعية',
        titleEn: 'Ad Creative Analyzer',
        description:
          'حلّل صور وفيديو الإعلانات: Hook, Offer, Visual Hierarchy, CTA مع Rubric لكل هدف ومنصة — مع A/B Variants.',
        icon: 'fa-photo-film',
        url: '/freetools/ad-creative-analyzer',
        isExternal: false,
        sortOrder: 9,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'free-ai-search',
        categoryId: 'cat-dev',
        title: 'باحث',
        titleEn: 'Bahath',
        description:
          'ابحث في الويب بالذكاء الاصطناعي واحصل على إجابات موثقة بالمصادر — سريع، ويب، وبحث متعمق. تجربة مثل Perplexity بهوية عربية.',
        icon: 'fa-magnifying-glass',
        url: '/freetools/ai-search',
        isExternal: false,
        sortOrder: 0,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'free-competitor-iq',
        categoryId: 'cat-dev',
        title: 'دراسة المنافسين',
        titleEn: 'Competitor Study',
        description:
          'حلّل منافسيك واكتشف فرص السوق — Discovery بعدة استعلامات، تنقية، تصنيف (مباشر/غير مباشر/ناشئ/قائد)، بروفايل كامل وتقرير قابل للتصدير.',
        icon: 'fa-chess-knight',
        url: '/freetools/competitor-intelligence',
        isExternal: false,
        sortOrder: 0,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-campaign-doctor',
        categoryId: 'cat-dev',
        title: 'Campaign Doctor — تشخيص الحملات',
        titleEn: 'Campaign Doctor',
        description:
          'حسابات deterministic للـ CTR/CPA/ROAS + Funnel Diagnosis + Next Best Action + What-If Simulator.',
        icon: 'fa-heart-pulse',
        url: '/freetools/campaign-doctor',
        isExternal: false,
        sortOrder: 10,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-content-strategy-builder',
        categoryId: 'cat-dev',
        title: 'باني استراتيجية المحتوى',
        titleEn: 'Content Strategy Builder',
        description:
          'من سياق البيزنس إلى نظام محتوى 30 يومًا: Pillars + Ideas ranked + Calendar + Briefs مع Meta AI.',
        icon: 'fa-layer-group',
        url: '/freetools/content-strategy-builder',
        isExternal: false,
        sortOrder: 11,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-teacher-thumbnail',
        categoryId: 'cat-dev',
        title: 'مصمم ثامبنيل المدرسين',
        titleEn: 'Teacher Thumbnail Designer',
        description:
          'اكتب فكرة عادية والأداة تحولها لثامبنيل يوتيوب احترافي MrBeast بالعربي — جودة اعلانية، CTR فوق 18%، نص عربي سليم من الموديل نفسه. يدعم كل المواد والثيمات.',
        icon: 'fa-chalkboard-teacher',
        url: '/tools/teacher-thumbnail',
        isExternal: false,
        sortOrder: 0,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-ugc-studio-pro',
        categoryId: 'cat-dev',
        title: 'استوديو UGC برو — إعلانات احترافية',
        titleEn: 'UGC Studio Pro — Pro Ads Studio',
        description:
          'استوديو داخلي احترافي: من رابط سلة/زيد/شوبيفاي أو صور + وصف يدوي إلى إعلان 9:16 جاهز. 20+ ممثلين بلهجات عربية متنوعة (خليجية نجدية/حجازية/إماراتية، مصرية قاهرية/صعيدية، شامية سورية/لبنانية/أردنية، عراقية بغدادية، مغاربية دارجة جزائرية/تونسية/مغربية، يمنية، سودانية) + فصحى + English. سكريبت AI أصيل بتعابير يومية وش تنتظر/شو تنتظر/مستني إيه/شنو تنتظر/شنو كتسنا/ماذا تنتظر/What are you waiting، Character Lock بثبات الوجه عبر PlayVeo، صور 3:4 وفيديو 9:16 R2 قابلة للتنزيل، Zero Crew Zero Editing، إنتاج تلقائي.',
        icon: 'fa-clapperboard',
        url: '/tools/ugc-studio-pro',
        isExternal: false,
        sortOrder: 2,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
    ],
  },
  {
    id: 'cat-generation',
    title: 'أدوات التوليد',
    titleEn: 'Generation Tools',
    icon: 'fa-wand-magic-sparkles',
    sortOrder: 1,
    isActive: true,
    createdAt: '',
    updatedAt: '',
    count: 8,
    tools: [
      {
        id: 'tool-calendar-studio',
        categoryId: 'cat-generation',
        title: 'استوديو الكالندر الموحّد',
        titleEn: 'Calendar Studio',
        description:
          'من مجالك وشعارك إلى كالندر 5/10/15 بوست بهوية واحدة — Spark Agent يخطط معك، والموديل يرسم كل بوست بالنص العربي جاهز للنشر، مع صورة مجمّعة + كل بوست لوحده',
        icon: 'fa-calendar-days',
        url: '/freetools/calendar-studio',
        isExternal: false,
        sortOrder: 0,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-product-studio',
        categoryId: 'cat-generation',
        title: 'استوديو المنتجات',
        titleEn: 'Product Studio',
        description:
          'أنشئ صور منتجات احترافية في بيئات وإضاءات مختلفة',
        icon: 'fa-box-open',
        url: 'https://ai.studio/apps/31d642f7-4e6d-46a1-8090-75f047aa35cf',
        isExternal: true,
        sortOrder: 1,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-product-models',
        categoryId: 'cat-generation',
        title: 'نماذج المنتجات',
        titleEn: 'Product Models',
        description:
          'أنشئ صور منتجاتك في خلفيات واقعية أو مولدة بالذكاء الاصطناعي',
        icon: 'fa-cube',
        url: 'https://ai.studio/apps/c53098f1-e1ee-4729-abd1-ed830d487d60',
        isExternal: true,
        sortOrder: 2,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-mockup-gen',
        categoryId: 'cat-generation',
        title: 'مولد الموك أب',
        titleEn: 'Mockup Generator',
        description:
          'حوّل تصميماتك إلى مشهد تسويقي واقعي على منتجات متنوعة',
        icon: 'fa-mobile-screen',
        url: 'https://ai.studio/apps/271e7197-5068-48da-80d1-b990cc98cf4e',
        isExternal: true,
        sortOrder: 3,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-cgi-ads',
        categoryId: 'cat-generation',
        title: 'مولد إعلانات CGI',
        titleEn: 'CGI Ads Generator',
        description:
          'حوّل منتجك إلى إعلان CGI واقعي في مشاهد عالمية',
        icon: 'fa-clapperboard',
        url: 'https://ai.studio/apps/ed71e5b0-bd96-4412-9878-2ca202b1a3c4',
        isExternal: true,
        sortOrder: 4,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-ugc-ads',
        categoryId: 'cat-generation',
        title: 'مولد إعلانات UGC',
        titleEn: 'UGC Ads Generator',
        description:
          'أنشئ إعلانات بأسلوب المؤثرين باستخدام صورة موبايل ومنتج',
        icon: 'fa-user-tie',
        url: 'https://ai.studio/apps/5ff90a5c-d4a9-494d-926f-228a7c7fca77',
        isExternal: true,
        sortOrder: 5,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-image-converter',
        categoryId: 'cat-generation',
        title: 'محوّل الصور (AI Mode)',
        titleEn: 'Image Converter',
        description:
          'ضع صورتك في أي مكان أو زمان أو نمط تخيله بضغطة زر',
        icon: 'fa-images',
        url: '/freetools/image-converter',
        isExternal: false,
        sortOrder: 6,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'free-design-md-generator',
        categoryId: 'cat-generation',
        title: 'مُولّد DESIGN.md',
        titleEn: 'DESIGN.md Generator',
        description:
          'حلّل أي موقع واحصل على ملف DESIGN.md جاهز يقرأه Cursor و Claude Code و Lovable لتوليد UI متّسق مع نظام التصميم.',
        icon: 'fa-wand-magic-sparkles',
        url: '/freetools/design-md-generator',
        isExternal: false,
        sortOrder: 10,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-storyboard',
        categoryId: 'cat-generation',
        title: 'ستوري بورد',
        titleEn: 'Storyboard',
        description: 'أنشئ ستوري بورد احترافي لمشاريعك السينمائية',
        icon: 'fa-film',
        url: 'https://ai.studio/apps/60a5d856-9c7b-485f-85eb-cd9e434f9b27',
        isExternal: true,
        sortOrder: 11,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
    ],
  },
  {
    id: 'cat-camera',
    title: 'أدوات الكاميرا',
    titleEn: 'Camera Tools',
    icon: 'fa-camera',
    sortOrder: 2,
    isActive: true,
    createdAt: '',
    updatedAt: '',
    count: 2,
    tools: [
      {
        id: 'tool-camera-assistant',
        categoryId: 'cat-camera',
        title: 'مساعد الكاميرا',
        titleEn: 'Camera Assistant',
        description:
          'استكشف زوايا وحركات كاميرا متنوعة من صورة واحدة',
        icon: 'fa-camera-retro',
        url: 'https://ai.studio/apps/ce7393c1-d145-4313-b9c6-c31987e55db7',
        isExternal: true,
        sortOrder: 1,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-virtual-measure',
        categoryId: 'cat-camera',
        title: 'القياس الافتراضي',
        titleEn: 'Virtual Measurement',
        description: 'جرّب الملابس على موديلات مختلفة بشكل افتراضي',
        icon: 'fa-ruler-combined',
        url: 'https://ai.studio/apps/db559de6-6ae9-4546-92fa-470b53c430d6',
        isExternal: true,
        sortOrder: 2,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
    ],
  },
  {
    id: 'cat-editing',
    title: 'أدوات التحرير',
    titleEn: 'Editing Tools',
    icon: 'fa-pen-to-square',
    sortOrder: 3,
    isActive: true,
    createdAt: '',
    updatedAt: '',
    count: 7,
    tools: [
      {
        id: 'tool-image-to-prompt',
        categoryId: 'cat-editing',
        title: 'صورة إلى موجه',
        titleEn: 'Image to Prompt',
        description: 'استخرج موجهات نصية دقيقة من أي صورة',
        icon: 'fa-bolt',
        url: '/freetools/image-to-prompt',
        isExternal: false,
        sortOrder: 1,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-image-editor',
        categoryId: 'cat-editing',
        title: 'محرر الصور',
        titleEn: 'Image Editor',
        description: 'قم بتعديل أجزاء من صورك باستخدام الذكاء الاصطناعي',
        icon: 'fa-pen',
        url: 'https://ai.studio/apps/de56cbe7-8b51-4e4a-a7c6-688e5b4290ef',
        isExternal: true,
        sortOrder: 2,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-video-eraser',
        categoryId: 'cat-editing',
        title: 'الممحاة السحرية للفيديو',
        titleEn: 'Magic Video Eraser',
        description: 'أزل أي كائن غير مرغوب فيه من الفيديو الخاص بك',
        icon: 'fa-table-cells',
        url: 'https://ai.studio/apps/5b74a63a-9855-4afa-b3b3-b0208c64ba2a',
        isExternal: true,
        sortOrder: 3,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-magic-frame',
        categoryId: 'cat-editing',
        title: 'الإطار السحري',
        titleEn: 'Magic Frame',
        description: 'استخرج لقطة من فيديو وحولها إلى صورة فنية',
        icon: 'fa-crop',
        url: 'https://ai.studio/apps/7069a7cd-12e0-4528-84e6-33929dc6b24a',
        isExternal: true,
        sortOrder: 4,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-colorize',
        categoryId: 'cat-editing',
        title: 'تلوين الصور',
        titleEn: 'Image Colorization',
        description: 'حوّل صورك بالأبيض والأسود إلى صور ملونة وواقعية',
        icon: 'fa-palette',
        url: 'https://ai.studio/apps/ac13c7a2-acd5-4f94-8471-2ce999a6839f',
        isExternal: true,
        sortOrder: 5,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-transcribe',
        categoryId: 'cat-editing',
        title: 'مفرّغ الفيديو والصوت',
        titleEn: 'Video & Audio Transcriber',
        description: 'حوّل المحتوى المسموع والمرئي إلى نص مكتوب',
        icon: 'fa-volume-high',
        url: 'https://ai.studio/apps/1afd7f5d-2ff3-4d55-8355-5b172236fdc3',
        isExternal: true,
        sortOrder: 6,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
      {
        id: 'tool-aspect-changer',
        categoryId: 'cat-editing',
        title: 'مغيّر الأبعاد',
        titleEn: 'Aspect Ratio Changer',
        description: 'غيّر أبعاد صورك مع ملء الفراغات بشكل ذكي',
        icon: 'fa-expand',
        url: 'https://ai.studio/apps/d6420ecc-ef61-4632-9980-9a7ff93c1b52',
        isExternal: true,
        sortOrder: 7,
        isActive: true,
        clicksCount: 0,
        createdAt: '',
        updatedAt: '',
      },
    ],
  },
  {
    id: 'cat-sora',
    title: 'أدوات Sora',
    titleEn: 'Sora Tools',
    icon: 'fa-video',
    sortOrder: 4,
    isActive: false,
    createdAt: '',
    updatedAt: '',
    count: 0,
    tools: [],
  },
]
